import Skeleton from "@material-ui/lab/Skeleton";


const LoadingRows: React.FC = () => {
	return (
		<div>
			{[...Array(14)].map((_e, i) =>
				<div key={i} className='skeleton-row'>
					<Skeleton variant="text" width={Math.random() * 16 + 7 + '%'} />
					<Skeleton variant="text" width={Math.random() * 16 + 7 + '%'} />
				</div>
			)}
		</div>
	);
}

export default LoadingRows;